import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { Button, Dropdown, Icon, Typography } from 'shared/ui'
import { type NumberSettingStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/ForwardCall/ui/ForwardCallActionEditContent/NumberSetting/store/NumberSettingStore'
import { SetUpNumberSettingsStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/ForwardCall/ui/ForwardCallActionEditContent/NumberCard/actions/setUp/SetUpNumberSettingsStore'
import styles from './styles.module.scss'

export const NumberCard = observer(
  ({
    store,
    className,
    replaceNumberSettings,
  }: {
    store: NumberSettingStore
    className: string
    replaceNumberSettings: (number: number, store: NumberSettingStore) => void
  }) => {
    const { isConfigured, phone, forwardToLabel, onDisable } = store

    const onSetUp = () => {
      new SetUpNumberSettingsStore(store, (newStore) =>
        replaceNumberSettings(store.phone.id, newStore)
      )
    }

    return (
      <div className={classNames(className, styles.wrap)}>
        <div className={styles.left}>
          {isConfigured && <Icon icon={'check2'} color={'var(--green-60)'} />}
          <div className={styles.column}>
            <Typography ariaLabel={'phone'} variant={'body-md-medium'}>
              {phone.formatted_number}
            </Typography>
            <Typography ariaLabel={'phone'} variant={'body-md-regular'} color={'tertiary'}>
              {isConfigured ? `Forward to → ${forwardToLabel}` : 'Forwarding not configured'}
            </Typography>
          </div>
        </div>
        {isConfigured ? (
          <Dropdown
            typeButton={'icon-button'}
            icon={'settings'}
            placement={'bottom-end'}
            items={[
              { id: 'edit', label: 'Edit', iconL: 'edit', onClick: onSetUp },
              { id: 'disable', label: 'Disable', iconL: 'slashCircle', onClick: onDisable },
            ]}
            iconButtonProps={{
              size: 'small',
              ariaLabel: 'IntegrationDropdown_button',
              variant: 'icon',
            }}
            ariaLabel={'IntegrationDropdown'}
          />
        ) : (
          <Button text={'Set up'} size={'small'} contained={'secondary'} onClick={onSetUp} />
        )}
      </div>
    )
  }
)
